<template>
    <transition name="modal">
        <div class="modal-mask">
            <div class="modal-wrapper">
                <div
                    class="modal-container"
                    v-bind:style="{ maxWidth: width }"
                >
                    <!--v-click-outside="closeModal"-->
                    <div class="modal-header">
                        <slot name="header"></slot>
                    </div>

                    <div :class="bodyBaseClass">
                        <slot name="body"></slot>
                    </div>

                    <div class="modal-footer">
                        <slot name="footer"></slot>
                    </div>
                </div>
            </div>
        </div>
    </transition>
</template>

<script>
export default {
    name: 'modal',
    methods: {
        closeModal: function() {
            this.$emit('close')
        }
    },
    props: {
        width: {
            type: String,
            default: '400px'
        },
        textAlign: {
            type: String,
            default: 'left'
        }
    },
    computed: {
        bodyBaseClass() {
            return `modal-body text-${this.textAlign}`
        }
    }
}
</script>

<style lang="scss">
/*
 * The following styles are auto-applied to elements with
 * transition="modal" when their visibility is toggled
 * by Vue.js.
 *
 * You can easily play with the modal transition by editing
 * these styles.
 */

.modal-enter {
    opacity: 0;
}

.modal-leave-active {
    opacity: 0;
}

.modal-enter .modal-container,
.modal-leave-active .modal-container {
    -webkit-transform: scale(1.1);
    transform: scale(1.1);
}
</style>
